Vue.component('additional-product', {
    props: {
        productId: Number,
    },
    data() {
        return {

        }
    },
    computed: {
        inCart() {
            for (let item of store.state.order.items)  {
                if (item.product.id == this.productId) {
                    return true;
                }
            }
            return false;
        },
        count() {
            for (let item of store.state.order.items)  {
                if (item.product.id == this.productId) {
                    return item.count;
                }
            }
            return 0;
        },
    },
    methods: {
        addInCart(count) {
            store.dispatch('setItemInCart', {product_id: this.productId, count: count});
        }
    }
});